// import React, { useState, useEffect, useRef } from "react";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import { FaCalendarAlt, FaUser, FaBuilding } from "react-icons/fa";
// import { useSelector, useDispatch } from "react-redux";
// import { MdBedroomParent } from "react-icons/md";
// import { setModifyDates } from "../Walk-In/redux/action"; // Import the action

// const RoomDates = () => {
//   const dispatch = useDispatch();

//   // Only use selectedModifyDates reducer
//   const { checkInDate, checkOutDate, daysCount } = useSelector(
//     (state) => state.selectedModifyDates
//   );

//   const { adults, children, rooms, childrenAges } = useSelector(
//     (state) => state.formDetails
//   );

//   // Get booking data from Redux
//   const bookingData = useSelector((state) => state.booking.selectedBooking);

//   const [showCalendar, setShowCalendar] = useState(false);
//   const [showTravellersDropdown, setShowTravellersDropdown] = useState(false);
//   const [showRoomsDropdown, setShowRoomsDropdown] = useState(false);
//   const [showCorporateCode, setShowCorporateCode] = useState(false);

//   const calendarRef = useRef(null);
//   const travellersRef = useRef(null);
//   const roomsRef = useRef(null);
//   const corporateRef = useRef(null);

//   // Initialize dates from API data on component mount
//   useEffect(() => {
//     if (bookingData?.checkindate && bookingData?.checkoutdate) {
//       const checkinDate = new Date(bookingData.checkindate);
//       const checkoutDate = new Date(bookingData.checkoutdate);

//       // Dispatch to setModifyDates reducer
//       dispatch(setModifyDates([checkinDate, checkoutDate]));

//       // Also set guests and rooms from booking data
//       dispatch({
//         type: "SET_ADULTS",
//         payload: bookingData.number_of_guests || 1,
//       });
//       dispatch({ type: "SET_CHILDREN", payload: 0 });
//       dispatch({ type: "SET_CHILDREN_AGES", payload: [] });
//       dispatch({ type: "SET_ROOMS", payload: bookingData.rooms || 1 });
//     } else {
//       // Fallback: Today and tomorrow if no booking data
//       const today = new Date();
//       const tomorrow = new Date(today);
//       tomorrow.setDate(today.getDate() + 1);
//       dispatch(setModifyDates([today, tomorrow]));
//     }
//   }, [bookingData, dispatch]);

//   const handleDateChange = (range) => {
//     if (range.length === 2) {
//       const [start, end] = range;
//       const checkinDate = new Date(start);
//       const checkoutDate = new Date(end);

//       // Normalize dates
//       checkinDate.setHours(0, 0, 0, 0);
//       checkoutDate.setHours(0, 0, 0, 0);

//       // Handle same-day selection
//       if (checkinDate.getTime() === checkoutDate.getTime()) {
//         checkoutDate.setDate(checkoutDate.getDate() + 1);
//       }

//       // Update the modify dates reducer
//       dispatch(setModifyDates([checkinDate, checkoutDate]));
//     }
//   };

//   const handleCounterChange = (e, type, value) => {
//     e.stopPropagation();

//     if (value >= 0) {
//       if (type === "children") {
//         dispatch({ type: "SET_CHILDREN", payload: value });
//         const newChildrenAges = [...childrenAges];
//         if (value > childrenAges.length) {
//           while (newChildrenAges.length < value) {
//             newChildrenAges.push(5);
//           }
//         } else {
//           newChildrenAges.length = value;
//         }
//         dispatch({ type: "SET_CHILDREN_AGES", payload: newChildrenAges });
//       } else {
//         dispatch({ type: `SET_${type.toUpperCase()}`, payload: value });
//       }
//     }
//   };

//   const handleAgeChange = (index, value) => {
//     const updatedAges = [...childrenAges];
//     updatedAges[index] = parseInt(value);
//     dispatch({ type: "SET_CHILDREN_AGES", payload: updatedAges });
//   };

//   const calculateNights = (startDate, endDate) => {
//     if (startDate && endDate) {
//       const timeDiff = endDate.getTime() - startDate.getTime();
//       const nights = Math.floor(timeDiff / (1000 * 3600 * 24));
//       return nights > 0 ? nights : 1;
//     }
//     return 0;
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         showCalendar &&
//         calendarRef.current &&
//         !calendarRef.current.contains(event.target)
//       ) {
//         setShowCalendar(false);
//       }
//       if (
//         showTravellersDropdown &&
//         travellersRef.current &&
//         !travellersRef.current.contains(event.target)
//       ) {
//         setShowTravellersDropdown(false);
//       }
//       if (
//         showRoomsDropdown &&
//         roomsRef.current &&
//         !roomsRef.current.contains(event.target)
//       ) {
//         setShowRoomsDropdown(false);
//       }
//       if (
//         showCorporateCode &&
//         corporateRef.current &&
//         !corporateRef.current.contains(event.target)
//       ) {
//         setShowCorporateCode(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [showCalendar, showTravellersDropdown, showRoomsDropdown, showCorporateCode]);

//   // Format dates for display
//   const formatDisplayDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return date.toDateString();
//   };

//   const today = new Date();
//   const minDate = bookingData?.checkindate
//     ? new Date(bookingData.checkindate)
//     : today;

//   const maxDate = new Date(minDate);
//   maxDate.setFullYear(maxDate.getFullYear() + 1);

//   return (
//     <div className="mt-6 ">
//       <div className="px-5">
//         <h1 className="text-2xl text-black font-bold mb-1">
//           {bookingData ? "Modify Your Reservation" : "Select Your Room"}
//         </h1>
//         <p className="">
//           {bookingData
//             ? "Modify your stay details and change your room preferences"
//             : "Enter your stay details and reserve your preferred room"}
//         </p>
//       </div>

//       {/* All Four Boxes in One Row */}
//       <div className="px-5 rounded-lg mt-4 relative flex gap-2">
//         {/* Date Selection */}
//         <div
//           className="flex flex-col border border-gray-700 p-3 rounded-md relative cursor-pointer w-2/6"
//           onClick={() => {
//             setShowCalendar(true);
//             setShowTravellersDropdown(false);
//             setShowRoomsDropdown(false);
//             setShowCorporateCode(false);
//           }}
//         >
//           <label className="text-gray-800 text-lg md:text-base sm:text-sm font-poppins font-bold">
//             Check-in & Check-Out Dates
//           </label>
//           <div className="flex items-center space-x-3">
//             <FaCalendarAlt size={20} className="text-gray-800 md:w-4 sm:w-3" />
//             <span className="text-gray-800 font-poppins text-base md:text-sm sm:text-xs font-semibold">
//               {checkInDate && checkOutDate
//                 ? `${formatDisplayDate(checkInDate)} - ${formatDisplayDate(checkOutDate)}`
//                 : "Select Dates"}
//             </span>
//             <div className="absolute top-2 right-2 py-1 px-2 rounded-md text-xs md:text-xs sm:text-xxs text-white font-semibold bg-black ">
//               {checkInDate && checkOutDate
//                 ? `(${daysCount} ${daysCount === 1 ? "Night" : "Nights"})`
//                 : ""}
//             </div>
//           </div>
//           {showCalendar && (
//             <div
//               ref={calendarRef}
//               className="absolute top-20 left-0 bg-white shadow-lg border rounded-md p-4 z-10 md:top-20 sm:top-14"
//             >
//               <Calendar
//                 onChange={handleDateChange}
//                 value={checkInDate && checkOutDate ? [new Date(checkInDate), new Date(checkOutDate)] : []}
//                 selectRange={true}
//                 className="react-calendar p-2 mt-4 bg-white w-full sm:w-3/4 lg:w-1/2 md:1/3"
//                 minDate={minDate}
//                 maxDate={maxDate}
//                 prev2Label={null}
//                 next2Label={null}
//                 minDetail="year"
//               />
//             </div>
//           )}
//         </div>

//         {/* Travellers Selection - Adjusted width */}
//         <div
//           ref={travellersRef}
//           className="flex flex-col border border-gray-800 p-3 rounded-md relative cursor-pointer w-1/4"
//           onClick={() => {
//             setShowTravellersDropdown(!showTravellersDropdown);
//             setShowCalendar(false);
//             setShowRoomsDropdown(false);
//             setShowCorporateCode(false);
//           }}
//         >
//           <label className="text-gray-800 text-lg md:text-base sm:text-sm font-poppins font-bold">
//             Guests
//           </label>
//           <div className="flex items-center space-x-2">
//             <FaUser className="text-gray-800" />
//             <span className="text-gray-800 text-base md:text-sm sm:text-xs font-poppins font-semibold">
//               {adults} Adults{children > 0 ? `, ${children} Children` : ""}
//             </span>
//           </div>
//           {showTravellersDropdown && (
//             <div
//               className="absolute top-20 left-0 bg-white shadow-lg font-poppins border rounded-md p-4 z-10 w-80"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {["adults", "children"].map((type) => {
//                 const value = { adults, children }[type];
//                 const minValue = type === "adults" ? 1 : 0;

//                 return (
//                   <div
//                     key={type}
//                     className="flex justify-between items-center py-2"
//                   >
//                     <span className="text-black capitalize font-semibold">
//                       {type}
//                     </span>
//                     <div className="flex items-center space-x-4">
//                       <button
//                         className={`px-4 py-2 rounded-full transition-colors ${value <= minValue
//                           ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                           : "bg-blue-100 text-blue-700 hover:bg-blue-200"
//                           }`}
//                         onClick={(e) =>
//                           value > minValue &&
//                           handleCounterChange(e, type, value - 1)
//                         }
//                         disabled={value <= minValue}
//                       >
//                         -
//                       </button>
//                       <span className="text-lg font-semibold">{value}</span>
//                       <button
//                         className="px-3.5 py-2 bg-blue-100 text-blue-700 rounded-full hover:bg-blue-200 transition-colors"
//                         onClick={(e) => handleCounterChange(e, type, value + 1)}
//                       >
//                         +
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })}

//               {/* Children Age Selection */}
//               {children > 0 && (
//                 <div className="mt-1">
//                   <p className="text-gray-500 text-sm mb-3">
//                     You can add children below 17 years old
//                   </p>
//                   <div className="grid grid-cols-2 gap-3">
//                     {childrenAges.map((age, index) => (
//                       <div key={index} className="flex flex-col">
//                         <label className="text-sm text-gray-700 mb-1">
//                           Child {index + 1} Age
//                         </label>
//                         <select
//                           value={age}
//                           onChange={(e) =>
//                             handleAgeChange(index, e.target.value)
//                           }
//                           className="border border-gray-300 rounded-md p-2"
//                         >
//                           {Array.from({ length: 17 }, (_, i) => (
//                             <option key={i + 1} value={i + 1}>
//                               {i + 1} {i === 0 ? "year" : "years"} old
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               <button
//                 className="w-full bg-black text-white px-4 py-2 mt-3 rounded-md font-poppins hover:text-white transition"
//                 onClick={() => setShowTravellersDropdown(false)}
//               >
//                 Done
//               </button>
//             </div>
//           )}
//         </div>

//         {/* Room Selection - Adjusted width */}
//         <div
//           ref={roomsRef}
//           className="flex flex-col border border-gray-800 p-3 rounded-md relative cursor-pointer w-1/5"
//           onClick={() => {
//             setShowRoomsDropdown(!showRoomsDropdown);
//             setShowCalendar(false);
//             setShowTravellersDropdown(false);
//             setShowCorporateCode(false);
//           }}
//         >
//           <label className="text-gray-800 text-lg md:text-base sm:text-sm font-poppins font-bold">
//             Rooms
//           </label>
//           <div className="flex items-center space-x-2">
//             <MdBedroomParent size={24} className="text-gray-800" />
//             <span className="text-gray-800 text-base md:text-sm sm:text-xs font-poppins font-semibold">
//               {rooms} Room(s)
//             </span>
//           </div>
//           {showRoomsDropdown && (
//             <div className="absolute top-20 left-0 bg-white shadow-lg border rounded-md p-4 z-10 w-76">
//               <div className="flex justify-between items-center py-2">
//                 <span className="text-black font-poppins capitalize font-semibold">
//                   Rooms
//                 </span>
//                 <div className="flex items-center space-x-4">
//                   <button
//                     className="px-4 py-2 bg-blue-100 text-blue-700 rounded-full hover:bg-blue-200 transition-colors"
//                     onClick={(e) =>
//                       handleCounterChange(e, "rooms", Math.max(1, rooms - 1))
//                     }
//                   >
//                     -
//                   </button>
//                   <span className="text-lg font-semibold">{rooms}</span>
//                   <button
//                     className={`px-3.5 py-2 rounded-full transition-colors ${rooms >= 1
//                       ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                       : "bg-blue-100 text-blue-700 hover:bg-blue-200"
//                       }`}
//                     onClick={(e) => {
//                       if (rooms < 1) {
//                         handleCounterChange(e, "rooms", rooms + 1);
//                       }
//                     }}
//                     disabled={rooms >= 1}
//                   >
//                     +
//                   </button>
//                 </div>
//               </div>
//               <p className="text-xs text-gray-900 mt-2 bg-yellow-200 px-2 py-1 rounded-sm">
//                 Reservations are limited to one room each. To reserve multiple rooms, please create separate reservations
//               </p>
//               <button
//                 className="w-full bg-black text-white px-4 py-2 mt-3 font-poppins rounded-md hover:text-white transition"
//                 onClick={() => setShowRoomsDropdown(false)}
//               >
//                 Done
//               </button>
//             </div>
//           )}
//         </div>

//       </div>
//     </div>
//   );
// };

// export default RoomDates;

import React, { useState, useEffect, useRef } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { FaCalendarAlt, FaUser } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { MdBedroomParent } from 'react-icons/md';
import { setModifyDates } from '../Walk-In/redux/action'; // Import the action

const RoomDates = () => {
  const dispatch = useDispatch();

  // Only use selectedModifyDates reducer
  const { checkInDate, checkOutDate, daysCount } = useSelector(
    (state) => state.selectedModifyDates
  );

  const { adults, children, rooms, childrenAges } = useSelector((state) => state.formDetails);

  // Get booking data from Redux
  const bookingData = useSelector((state) => state.booking.selectedBooking);

  const [showCalendar, setShowCalendar] = useState(false);
  const [showTravellersDropdown, setShowTravellersDropdown] = useState(false);
  const [showRoomsDropdown, setShowRoomsDropdown] = useState(false);

  const calendarRef = useRef(null);
  const travellersRef = useRef(null);
  const roomsRef = useRef(null);

  // Initialize dates from API data on component mount
  useEffect(() => {
    if (bookingData?.checkindate && bookingData?.checkoutdate) {
      const checkinDate = new Date(bookingData.checkindate);
      const checkoutDate = new Date(bookingData.checkoutdate);

      // Dispatch to setModifyDates reducer
      dispatch(setModifyDates([checkinDate, checkoutDate]));

      // Also set guests and rooms from booking data
      dispatch({
        type: 'SET_ADULTS',
        payload: bookingData.number_of_guests || 1,
      });
      dispatch({ type: 'SET_CHILDREN', payload: 0 });
      dispatch({ type: 'SET_CHILDREN_AGES', payload: [] });
      dispatch({ type: 'SET_ROOMS', payload: bookingData.rooms || 1 });
    } else {
      // Fallback: Today and tomorrow if no booking data
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      dispatch(setModifyDates([today, tomorrow]));
    }
  }, [bookingData, dispatch]);

  const handleDateChange = (range) => {
    if (range.length === 2) {
      const [start, end] = range;
      const checkinDate = new Date(start);
      const checkoutDate = new Date(end);

      // Normalize dates
      checkinDate.setHours(0, 0, 0, 0);
      checkoutDate.setHours(0, 0, 0, 0);

      // Handle same-day selection
      if (checkinDate.getTime() === checkoutDate.getTime()) {
        checkoutDate.setDate(checkoutDate.getDate() + 1);
      }

      // Update the modify dates reducer
      dispatch(setModifyDates([checkinDate, checkoutDate]));
    }
  };

  const handleCounterChange = (e, type, value) => {
    e.stopPropagation();

    if (value >= 0) {
      if (type === 'children') {
        dispatch({ type: 'SET_CHILDREN', payload: value });
        const newChildrenAges = [...childrenAges];
        if (value > childrenAges.length) {
          while (newChildrenAges.length < value) {
            newChildrenAges.push(5);
          }
        } else {
          newChildrenAges.length = value;
        }
        dispatch({ type: 'SET_CHILDREN_AGES', payload: newChildrenAges });
      } else {
        dispatch({ type: `SET_${type.toUpperCase()}`, payload: value });
      }
    }
  };

  const handleAgeChange = (index, value) => {
    const updatedAges = [...childrenAges];
    updatedAges[index] = parseInt(value);
    dispatch({ type: 'SET_CHILDREN_AGES', payload: updatedAges });
  };

  const calculateNights = (startDate, endDate) => {
    if (startDate && endDate) {
      const timeDiff = endDate.getTime() - startDate.getTime();
      const nights = Math.floor(timeDiff / (1000 * 3600 * 24));
      return nights > 0 ? nights : 1;
    }
    return 0;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showCalendar && calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
      if (
        showTravellersDropdown &&
        travellersRef.current &&
        !travellersRef.current.contains(event.target)
      ) {
        setShowTravellersDropdown(false);
      }
      if (showRoomsDropdown && roomsRef.current && !roomsRef.current.contains(event.target)) {
        setShowRoomsDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showCalendar, showTravellersDropdown, showRoomsDropdown]);

  // Format dates for display
  const formatDisplayDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toDateString();
  };

  const today = new Date();
  const minDate = bookingData?.checkindate ? new Date(bookingData.checkindate) : today;

  const maxDate = new Date(minDate);
  maxDate.setFullYear(maxDate.getFullYear() + 1);

  return (
    <div className="mt-6 ">
      <div className="px-5">
        <h1 className="text-2xl text-black font-bold mb-1">
          {bookingData ? 'Modify Your Reservation' : 'Select Your Room'}
        </h1>
        <p className="">
          {bookingData
            ? 'Modify your stay details and change your room preferences'
            : 'Enter your stay details and reserve your preferred room'}
        </p>
      </div>
      <div className="px-5 rounded-lg mt-4 relative flex gap-3">
        {/* Date Selection */}
        <div
          className="flex flex-col border border-gray-700 p-3 rounded-md relative cursor-pointer w-1/3"
          onClick={() => {
            setShowCalendar(true);
            setShowTravellersDropdown(false);
            setShowRoomsDropdown(false);
          }}
        >
          <label className="text-gray-800 text-lg font-poppins font-bold">
            Check-in & Check-Out Dates
          </label>
          <div className="flex items-center space-x-3">
            <FaCalendarAlt size={20} className="text-gray-800" />
            <span className="text-gray-800 font-poppins text-base font-semibold">
              {checkInDate && checkOutDate
                ? `${formatDisplayDate(checkInDate)} - ${formatDisplayDate(checkOutDate)}`
                : 'Select Dates'}
            </span>
            <div className="absolute top-2 right-2 p-2 rounded-md text-xs text-white font-semibold bg-black ">
              {checkInDate && checkOutDate
                ? `(${daysCount} ${daysCount === 1 ? 'Night' : 'Nights'})`
                : ''}
            </div>
          </div>
          {showCalendar && (
            <div
              ref={calendarRef}
              className="absolute top-20 left-0 bg-white shadow-lg border rounded-md p-4 z-10 "
            >
              <Calendar
                onChange={handleDateChange}
                value={
                  checkInDate && checkOutDate ? [new Date(checkInDate), new Date(checkOutDate)] : []
                }
                selectRange={true}
                className="react-calendar p-2 mt-4 bg-white w-full sm:w-3/4 lg:w-1/2 md:1/3"
                minDate={minDate}
                maxDate={maxDate}
                prev2Label={null}
                next2Label={null}
                minDetail="year"
              />
            </div>
          )}
        </div>

        {/* Travellers Selection */}
        <div
          ref={travellersRef}
          className="flex flex-col border border-gray-800 p-3 rounded-md relative cursor-pointer w-1/3"
          onClick={() => {
            setShowTravellersDropdown(!showTravellersDropdown);
            setShowCalendar(false);
            setShowRoomsDropdown(false);
          }}
        >
          <label className="text-gray-800 text-lg font-poppins font-bold">Guests</label>
          <div className="flex items-center space-x-2">
            <FaUser className="text-gray-800" />
            <span className="text-gray-800 text-base font-poppins font-semibold">
              {adults} Adults{children > 0 ? `, ${children} Children` : ''}
            </span>
          </div>
          {showTravellersDropdown && (
            <div
              className="absolute top-20 left-0 bg-white shadow-lg font-poppins border rounded-md p-4 z-10 w-full"
              onClick={(e) => e.stopPropagation()}
            >
              {['adults', 'children'].map((type) => {
                const value = { adults, children }[type];
                const minValue = type === 'adults' ? 1 : 0;

                return (
                  <div key={type} className="flex justify-between items-center py-2">
                    <span className="text-black capitalize font-semibold">{type}</span>
                    <div className="flex items-center space-x-4">
                      <button
                        className={`px-4 py-2 rounded-full transition-colors ${
                          value <= minValue
                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                            : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                        }`}
                        onClick={(e) => value > minValue && handleCounterChange(e, type, value - 1)}
                        disabled={value <= minValue}
                      >
                        -
                      </button>
                      <span className="text-lg font-semibold">{value}</span>
                      <button
                        className="px-3.5 py-2 bg-blue-100 text-blue-700 rounded-full hover:bg-blue-200 transition-colors"
                        onClick={(e) => handleCounterChange(e, type, value + 1)}
                      >
                        +
                      </button>
                    </div>
                  </div>
                );
              })}

              {/* Children Age Selection */}
              {children > 0 && (
                <div className="mt-1">
                  <p className="text-gray-500 text-sm mb-3">
                    You can add children below 5 years old
                  </p>
                  <div className="grid grid-cols-2 gap-3">
                    {childrenAges.map((age, index) => (
                      <div key={index} className="flex flex-col">
                        <label className="text-sm text-gray-700 mb-1">Child {index + 1} Age</label>
                        <select
                          value={age}
                          onChange={(e) => handleAgeChange(index, e.target.value)}
                          className="border border-gray-300 rounded-md p-2"
                        >
                          {Array.from({ length: 5 }, (_, i) => (
                            <option key={i + 1} value={i + 1}>
                              {i + 1} {i === 0 ? 'year' : 'years'} old
                            </option>
                          ))}
                        </select>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <button
                className="w-full bg-black text-white px-4 py-2 mt-3 rounded-md font-poppins hover:text-white transition"
                onClick={() => setShowTravellersDropdown(false)}
              >
                Done
              </button>
            </div>
          )}
        </div>

        {/* Room Selection */}
        <div
          ref={roomsRef}
          className="flex flex-col border border-gray-800 p-3 rounded-md relative cursor-pointer w-1/3"
          onClick={() => {
            setShowRoomsDropdown(!showRoomsDropdown);
            setShowCalendar(false);
            setShowTravellersDropdown(false);
          }}
        >
          <label className="text-gray-800 text-lg font-poppins font-bold">Rooms</label>
          <div className="flex items-center space-x-2">
            <MdBedroomParent size={24} className="text-gray-800" />
            <span className="text-gray-800 font-poppins text-base font-semibold">
              {rooms} Room(s)
            </span>
          </div>
          {showRoomsDropdown && (
            <div className="absolute top-20 left-0 bg-white shadow-lg border rounded-md p-4 z-10 w-full">
              <div className="flex justify-between items-center py-2">
                <span className="text-black font-poppins capitalize font-semibold">Rooms</span>
                <div className="flex items-center space-x-4">
                  <button
                    className="px-4 py-2 bg-blue-100 text-blue-700 rounded-full hover:bg-blue-200 transition-colors"
                    onClick={(e) => handleCounterChange(e, 'rooms', Math.max(1, rooms - 1))}
                  >
                    -
                  </button>
                  <span className="text-lg font-semibold">{rooms}</span>
                  <button
                    className={`px-3.5 py-2 rounded-full transition-colors ${
                      rooms >= 1
                        ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                        : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                    }`}
                    onClick={(e) => {
                      if (rooms < 1) {
                        handleCounterChange(e, 'rooms', rooms + 1);
                      }
                    }}
                    disabled={rooms >= 1}
                  >
                    +
                  </button>
                </div>
              </div>
              <p className="text-sm text-gray-900 mt-2 bg-yellow-200 px-2 py-1 rounded-sm">
                Reservations are limited to one room each. To reserve multiple rooms, please create
                separate reservations
              </p>
              <button
                className="w-full bg-black text-white px-4 py-2 mt-3 font-poppins rounded-md hover:text-white transition"
                onClick={() => setShowRoomsDropdown(false)}
              >
                Done
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RoomDates;
